import { CookieUtil } from "../../utils";

const asyncIdentity = async () => {};

export const updateAppMinVersion = window.updateMinVersion || asyncIdentity;

export const getCurrentVersion = window.getAppVersion || asyncIdentity;

const appVersionNotification = "appVersionNotified";
const appVersionCheckAt = "appVersionCheckedAt";

export const isAppVersionNotified = () =>
  CookieUtil.get(appVersionNotification);

export const getLastCheckAppVersion = () => CookieUtil.get(appVersionCheckAt);

export const lastCheckAppVersionTimeout = 1 * 60 * 60;

export const setLastCheckAppVersion = (
  time = lastCheckAppVersionTimeout,
  value
) => CookieUtil.setFor(appVersionCheckAt, value, { time });

export const appVersionNotifyTime = 24 * 60 * 60;

export const setAppVersionNotified = (
  time = appVersionNotifyTime,
  value = true
) => CookieUtil.setFor(appVersionNotification, value, { time });
